module.exports = __webpack_public_path__ + "static/media/sign-in-mobile-cloud.6acc16de.png";